// removed by extract-text-webpack-plugin
module.exports = {"container":"_-src-components-StaleLoader-styles---container---3t9OJ","loaderOverlay":"_-src-components-StaleLoader-styles---loaderOverlay---1kj-E","fadein":"_-src-components-StaleLoader-styles---fadein---1UK-N"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StaleLoader/styles.css
// module id = 650
// module chunks = 0